import {Component} from '@angular/core';
import {IDataCellDisplayComponent} from '../../../../sdk/src/data-cell-display/idata-cell-display/idata-cell-display.component';
import {Skeleton} from 'primeng/skeleton';
import {UserCaching} from '../../caching/user.caching';
import {lastValueFrom} from 'rxjs';
import {CpmCUserApiModel} from '../../../../gen/cpm-c-api-ts/src/models/c-global/cpmc-user.api-model';

/**
 * User data cell display component
 */
@Component({
    selector: 'app-user-data-cell-display',
    templateUrl: './user-data-cell-display.component.html',
    imports: [Skeleton]
})
export class UserDataCellDisplayComponent extends IDataCellDisplayComponent<unknown, unknown> {
    protected _user?: CpmCUserApiModel;

    // ===============================================================
    // ===============================================================

    /**
     * On refresh (Error handling and refresh is done in the parent)
     */
    protected override async onRefresh(): Promise<void> {
        this.showLoading = true;
        if (!this.value) {
            this._user = undefined;
            return;
        }

        try {
            const user = await lastValueFrom(UserCaching.getUserBatched(this.value as string));

            this._user = user;
        } catch {
            // Do nothing
        }
    }
}
